import { isSnoozeActive } from './snooze-storage';

let closedAt = 0;
let confirmedActionId: string | null = null;

export function notifyDialogClosed() {
  closedAt = Date.now();
}

/**
 * Records internally that the dialog was confirmed for the given action ID.
 * Subsequent requests carrying the same action ID will skip the dialog,
 * even if they arrive outside the grace period.
 * Action IDs must be unique per form submission to avoid stale skips.
 */
export function recordActionConfirmed(actionId: string) {
  confirmedActionId = actionId;
}

/** When a dialog was closed recently, a snooze is active, a dialog is already open, or the action was already confirmed, skip the confirm dialog to avoid spamming the user */
export function shouldSkipConfirm(actionId?: string, graceMs = 2000) {
  if (isSnoozeActive()) {
    return true;
  }
  if (actionId && actionId === confirmedActionId) {
    return true;
  }
  const dialogOpen = document.querySelector('[id^="dialog-"]') !== null;
  const recentlyClosed = Date.now() - closedAt < graceMs;
  return dialogOpen || recentlyClosed;
}
